'use strict';

/**
 * Pricing widget — switchable lesson detail.
 */
export function initPricingWidget() {
    const widgets = document.querySelectorAll('[data-pricing-widget]');

    if (widgets.length === 0) {
        return;
    }

    widgets.forEach((widget) => {
        if (widget.dataset.pricingInitialized === 'true') {
            return;
        }
        widget.dataset.pricingInitialized = 'true';

        const buttons = widget.querySelectorAll('[data-lesson-btn]');
        const titleEl = widget.querySelector('[data-detail-title]');
        const descEl = widget.querySelector('[data-detail-desc]');
        const rowsEl = widget.querySelector('[data-detail-rows]');

        if (!buttons.length || !titleEl || !descEl || !rowsEl) {
            return;
        }

        const details = {};
        widget.querySelectorAll('[data-lesson-detail]').forEach((el) => {
            details[el.dataset.lessonDetail] = el.innerHTML;
        });

        /**
         * Mark price rows without a meaningful price as unavailable.
         *
         * @param {HTMLElement} container
         */
        function markUnavailableRows(container) {
            const rows = container.querySelectorAll('.price-row');

            rows.forEach((row) => {
                const priceEl = row.querySelector('.price-value');
                if (!priceEl) {
                    return;
                }

                const raw = priceEl.textContent.trim();
                // Empty, dash, "0", "0 Kč", "+ 0 Kč" → unavailable
                const numeric = raw.replace(/[^\d]/g, '');
                const isEmpty = raw === '' || raw === '—' || raw === '-';
                const isZero = numeric === '' || parseInt(numeric, 10) === 0;

                if (isEmpty || isZero) {
                    row.classList.add('is-unavailable');
                    priceEl.textContent = '—';
                } else {
                    row.classList.remove('is-unavailable');
                }
            });
        }

        function selectLesson(btn) {
            buttons.forEach((b) => {
                b.classList.remove('bg-earth', 'text-paper', 'border-earth');
                b.classList.add('bg-paper', 'text-ink', 'border-sand');

                const check = b.querySelector('.check-icon');
                if (check) check.classList.add('opacity-0');

                const desc = b.querySelector('.lesson-btn-desc');
                if (desc) {
                    desc.classList.add('text-cocoa/70');
                    desc.classList.remove('text-paper/80');
                }
            });

            btn.classList.remove('bg-paper', 'text-ink', 'border-sand');
            btn.classList.add('bg-earth', 'text-paper', 'border-earth');

            const activeCheck = btn.querySelector('.check-icon');
            if (activeCheck) activeCheck.classList.remove('opacity-0');

            const activeDesc = btn.querySelector('.lesson-btn-desc');
            if (activeDesc) {
                activeDesc.classList.remove('text-cocoa/70');
                activeDesc.classList.add('text-paper/80');
            }

            titleEl.textContent = btn.dataset.lessonName || '';
            descEl.textContent = btn.dataset.lessonDesc || '';

            const id = btn.dataset.lessonId;
            if (id && details[id] !== undefined) {
                rowsEl.innerHTML = details[id];
                markUnavailableRows(rowsEl);
            }
        }

        buttons.forEach((btn) => {
            btn.addEventListener('click', () => selectLesson(btn));
        });

        selectLesson(buttons[0]);
    });
}